// extracted by mini-css-extract-plugin
export default {"card":"bookingMeta_card__96HwN","body":"bookingMeta_body__urUxz","addBooking":"bookingMeta_addBooking__cz8IL","totalFound":"bookingMeta_totalFound__MdmZB"};